import React from 'react'
import { User } from 'firebase'
import { useParams } from 'react-router-dom'
import { BikeForm } from './bike-form'
import { FirestoreDocument } from '@react-firebase/firestore'
import { firebaseApp } from '../firebase/firebase'

export function EditBike({ user }: { user: User }) {
  const { id } = useParams<any>()
  const docPath = `users/${user.uid}/bikes/${id}`
  return (
    <FirestoreDocument path={docPath}>
      {(d) =>
        d.isLoading ? (
          'Loading'
        ) : d.value ? (
          <BikeForm
            bike={d.value}
            onSave={async (bike) => await firebaseApp.firestore().doc(docPath).update(bike)}
          />
        ) : (
          `No bike found with id ${id}`
        )
      }
    </FirestoreDocument>
  )
}
